import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Running extends Component {
    render() {
        return (
            <Container fluid>
                <p>This is the running page.</p>
            </Container>
        );
    }
}

export default Running;